import { format } from 'date-fns';
import { toZonedTime } from 'date-fns-tz';

export const formatDateForInput = (date, timezone) => {
  if (!date) return null;
  return format(toZonedTime(date, timezone), 'yyyy-MM-dd HH:mm');
};
